import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeThingsToDoFilters(list) {
    return {
        type: 'STORE_THINGS_TO_DO_FILTERS',
        list: list.data
    }
}

export function getThingsToDoFilters() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/things_to_do/filters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeThingsToDoFilters(json));
                    if (json.success) {
                        dispatch(getThingsToDoList());
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function stoteThingsToDoDetailsUpdate(bool) {
    return {
        type: 'STORE_THINGS_TO_DO_DETAILS_UPDATE', bool
    }
}

export function storeThingsToDoList(list) {
    return {
        type: 'STORE_THINGS_TO_DO_LISTS',
        list: list.data
    }
}

export function clearThingsToDoList() {
    return { type: 'CLEAR_THINGS_TO_DO_LISTS' }
}

export function getThingsToDoList(search = "", loc = "", cat = "") {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(clearThingsToDoList());
        fetch(API_URL + '/api/things_to_do/list?key=' + search + "&location=" + loc + "&category=" + cat , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    if (json.success && json.data.tours.length > 0) {
                        dispatch(getThingsToDoListMore(search, loc, cat, json.data.tours[json.data.tours.length - 1].id, false));
                    }
                    dispatch(storeThingsToDoList(json));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function updateThingsToDoListArray(bool) {
    return {
        type: 'UPDATE_THINGS_TO_DO_LIST_ARRAY', bool
    }
}


export function updateThingsToDoList(data) {
    return {
        type: 'UPDATE_THINGS_TO_DO_MORE_LISTS',
        list: data
    }
}

export function getThingsToDoListMore(search = "", loc = "", cat = "", id, loader = false) {
    return function (dispatch) {
        dispatch(pageGifLoader(loader));
        dispatch(updateThingsToDoListArray(false));
        fetch(API_URL + '/api/things_to_do/listMore?key=' + search + "&location=" + loc + "&category=" + cat  + "&id=" + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    dispatch(updateThingsToDoListArray(json.success && json.data.tours.length > 0));
                    dispatch(updateThingsToDoList(json.data));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}